"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_1 = __importDefault(require("react"));
var PREFIX = 'Toast';
var classes = {
    root: "".concat(PREFIX, "-root"),
};
var StyledIconButton = (0, styles_1.styled)(material_1.IconButton)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.root)] = {
            '& .MuiSnackbarContent-root': {
                padding: theme.spacing(1, 2),
                wordBreak: 'break-word',
                lineHeight: '1.125rem',
                whiteSpace: 'pre-wrap',
                borderRadius: '10px',
                background: theme.palette.common.white,
                color: theme.palette.text.primary,
                '&:hover': {
                    background: 'rgb(255, 243, 247) none repeat scroll 0% 0%',
                },
            },
        },
        _b);
});
var Toast = function (props) {
    var _a = __read(react_1.default.useState(!!props.open), 2), open = _a[0], setOpen = _a[1];
    return ((0, jsx_runtime_1.jsx)(material_1.Snackbar, __assign({}, props, { classes: { root: classes.root }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, open: open, autoHideDuration: 5000, onClose: function () { return setOpen(false); }, message: props.message, action: ((0, jsx_runtime_1.jsx)(StyledIconButton, __assign({ size: "small", "aria-label": "close", color: "inherit", onClick: function () { return setOpen(false); } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, { fontSize: "small" }) }))) })));
};
exports.default = Toast;
